<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="about" class="about">

  <div class="container" data-aos="fade-up">
    <div class="row gx-0">

      <div class="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
        <div class="content">
          <h3>{text(block, 'preheadline')}</h3>
          <h2>{text(block, 'headline')}</h2>
          <p>
            {@html richtext(block, 'body')}
          </p>
          <div class="text-center text-lg-start">
            <a href="{url(block, 'button')}" class="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center">
              <span>{text(block, 'button')}</span>
              <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="col-lg-6 d-flex align-items-center p-4" data-aos="zoom-out" data-aos-delay="200">
        <img src="{image(block, 'picture', [800, null])}" style="width: 100%;" alt="">
      </div>

    </div>
  </div>

</section>
